import { Injectable, inject } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { LocationsService } from '@era/osupdates-sdk';
import { safeMap } from '../effects.helpers';
import {
  CurrentLocationViewActions,
  LocationAllowedOsUpdatesApiActions,
  LocationAllowedOsUpdatesResolverActions,
} from './location-allowed-os-updates.actions';

@Injectable()
export class LocationAllowedOsUpdateEffects {
  private readonly actions = inject(Actions);
  private readonly locationsService = inject(LocationsService);

  /**
   * (Re)Load the allowed OS updates for the location.
   * Effect: we load the state from the API.
   */
  AllowedOsUpdatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(LocationAllowedOsUpdatesResolverActions.requested, LocationAllowedOsUpdatesApiActions.updated),
      mergeMap(({ locationId }) =>
        safeMap(
          this.locationsService.getAllowedOsUpdatesForLocation({ locationId }),
          (updates) => {
            return LocationAllowedOsUpdatesApiActions.loaded({
              locationAllowedOsUpdates: updates.map((update) => {
                return {
                  ...update,
                  locationId,
                };
              }),
            });
          },
          (error) => LocationAllowedOsUpdatesApiActions.loadedError({ error })
        )
      )
    );
  });

  /**
   * Update/save the subset of possible OS updates as allowed for the location.
   * Effect: we update the sub set of allowed OS updates to the API.
   */
  UpdateLocationAllowedOsUpdateEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CurrentLocationViewActions.update),
      mergeMap(({ locationId, locationAllowedOsUpdates }) =>
        safeMap(
          this.locationsService.updateAllowedOsUpdatesForLocation({
            locationId,
            osUpdateKey: locationAllowedOsUpdates.map((a) => ({ productKey: a.productKey, version: a.version })),
          }),
          () =>
            LocationAllowedOsUpdatesApiActions.updated({
              locationId,
              locationAllowedOsUpdates,
            }),
          (error) => LocationAllowedOsUpdatesApiActions.updatedError({ error })
        )
      )
    );
  });
}
